module.exports = __webpack_public_path__ + "images/application/illustrations/webhook-05b343d6.svg";